import React, { useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { Link } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectors as settingsSelectors } from 'state/settings';
import config from 'config';
import { selectors as orderSelectors, selectorsByType } from 'state/order';
import { constants as errorConstants } from 'utils/errors';
import { GirdedInfoIcon } from 'refactored/ui/icons';

const QuoteMessageErrorRouteBanner = ({ className }) => {
  const { t } = useTranslation('Summary');
  const country = useSelector(settingsSelectors.getCountry);
  const secondaryLink = useMemo(() => config.OFFER_LINKS[country], [country]);
  return (
    <div className={`${className} quote-message__banner`}>
      <div className="quote-message__message">
        <GirdedInfoIcon className={'disabled-info-icon'} />
        <p>{t('quote_additional_message_contact')}</p>
      </div>
      {!!secondaryLink && (
        <Link
          href={secondaryLink}
          skin="light"
          text={t('quote_additional_message_secondary_link')}
          target="_blank"
          className="quote-message__secondary-link"
        />
      )}
    </div>
  );
};

const QuoteMessageErrorLHExpressBanner = ({ className }) => {
  const { t } = useTranslation('Summary');
  const lhExpressLink = useMemo(() => config.LH_EXPRESS_LINK, []);

  return (
    <div className={`${className} quote-message__banner`}>
      <div className="quote-message__message">
        <GirdedInfoIcon className={'disabled-info-icon'} />
        <p>{t('quote_lh_express_error_vehicle_type_message')}</p>
      </div>
      <Link
        href={lhExpressLink}
        skin="light"
        text={t('quote_lh_express_error_vehicle_type_message_secondary_link')}
        target="_blank"
        className="quote-message__secondary-link"
      />
    </div>
  );
};

const QuoteMessageError = ({ className }) => {
  const { t } = useTranslation('Summary');
  const phone = useSelector(settingsSelectors.getContactPhoneWithAreaCode);
  const orderType = useSelector(orderSelectors.getTypeOfOrder);
  const errorType = useSelector(
    selectorsByType.quote[orderType].getQuoteErrorType
  );

  return (
    <div className={className} data-testid="quote-message">
      {(errorType === errorConstants.QUOTE_ERRORS.LH_EXPRESS_VEHICLE_TYPE && (
        <QuoteMessageErrorLHExpressBanner />
      )) || <QuoteMessageErrorRouteBanner />}

      <div className="reachUsText">
        {t('quote_additional_message_reach_us')} <span>{phone}</span>
      </div>
    </div>
  );
};

QuoteMessageError.propTypes = {
  className: PropTypes.string,
};

export default QuoteMessageError;
